(() => {
  if (customElements.get('sdc-shark-product')) return;
  customElements.define('sdc-shark-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.words = JSON.parse(this.querySelector('[data-words]').textContent);
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.money = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency });
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.form = this.querySelector('form');
      this.button = this.querySelector('[data-add]');
      this.sticky = this.querySelector('.shark-sticky');
      if (this.sticky) {
        document.body.appendChild(this.sticky);
        this.sticky.querySelector('[data-sticky-add]').addEventListener('click', () => this.form.requestSubmit(), options);
        this.syncSticky = () => {
          this.sticky.hidden = this.button.getBoundingClientRect().bottom >= 0;
          document.body.classList.toggle('shark-has-sticky', !this.sticky.hidden);
        };
        document.addEventListener('scroll', this.syncSticky, { ...options, passive: true });
        window.addEventListener('resize', this.syncSticky, options);
        window.addEventListener('load', this.syncSticky, options);
        this.observer = new IntersectionObserver(this.syncSticky);
        this.observer.observe(this.button);
      }
      this.querySelectorAll('[name="shark_offer"], [data-character]').forEach(input => input.addEventListener('change', () => { this.querySelector('[data-error]').hidden = true; this.update(); }, options));
      this.form.addEventListener('submit', event => this.add(event), options);
      this.querySelectorAll('[data-photo]').forEach(button => button.addEventListener('click', () => {
        const image = this.querySelector('[data-main-photo]');
        image.src = button.dataset.photo;
        image.removeAttribute('srcset');
        image.alt = button.dataset.alt;
        const caption = this.querySelector('[data-size-caption]');
        if (caption) caption.hidden = button.dataset.scale !== 'true';
        this.querySelectorAll('[data-photo]').forEach(photo => photo.setAttribute('aria-current', String(photo === button)));
      }, options));
      const tabs = [...this.querySelectorAll('[data-info-tab]')];
      const activateTab = tab => {
        tabs.forEach(button => {
          const active = button === tab;
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
          this.querySelector('#' + button.getAttribute('aria-controls')).hidden = !active;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab), options);
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          activateTab(tabs[next]); tabs[next].focus();
        }, options);
      });
      document.querySelectorAll('[data-shark-pair]').forEach(button => button.addEventListener('click', () => { this.querySelector('input[value="pair"]').checked = true; this.update(); this.form.requestSubmit(); }, options));
      this.update();
      this.delivery();
      this.syncSticky?.();
      this.timer = setInterval(() => this.delivery(), 1000);
    }
    disconnectedCallback() {
      this.abort?.abort();
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.sticky?.remove();
      document.body.classList.remove('shark-has-sticky');
    }
    get duo() { return this.variants[0]; }
    get offer() { return this.querySelector('[name="shark_offer"]:checked').value; }
    get basket() { return this.variants.find(variant => String(variant.id) === this.dataset.basketVariant); }
    get selected() {
      if (this.offer === 'basket') return this.basket;
      if (this.offer === 'pair') return this.duo;
      return this.variants.find(variant => String(variant.id) === this.querySelector('[data-character]').value);
    }
    update() {
      const single = this.offer === 'single';
      const basket = this.offer === 'basket';
      this.querySelectorAll('[data-basket-pillows], [data-basket-details]').forEach(node => node.hidden = !basket);
      this.querySelector('.shark-info-tabs .sdc-specs').classList.toggle('shark-basket-specs', basket);
      this.querySelector('.shark-character').hidden = !single;
      const current = this.selected;
      this.querySelector('[name="id"]').value = current.id;
      this.querySelector('[data-total]').textContent = this.money.format(Number(current.price));
      this.button.textContent = this.busy ? this.words.adding : this.words.pair_cta;
      this.button.disabled = this.busy || !current.available;
      this.querySelectorAll('[data-contents]').forEach(node => node.textContent = single ? (String(current.id) === String(this.variants[2].id) ? this.words.dudu_contents : this.words.bubu_contents) : this.words.duo_contents);
      const singlePhoto = this.querySelector('[data-single-photo]');
      if (singlePhoto) {
        const dudu = String(this.querySelector('[data-character]').value) === String(this.variants[2].id);
        const photoVariant = dudu ? this.variants[2] : this.variants[1];
        if (photoVariant.cutout || photoVariant.image) singlePhoto.querySelector('img').src = photoVariant.cutout || photoVariant.image;
        singlePhoto.querySelector('img').alt = this.querySelector('[data-character] option:checked').textContent;
      }
      const singlePrice = this.querySelector('[data-single-price]');
      if (singlePrice && single) singlePrice.textContent = this.money.format(Number(current.price));
      const saving = Number(this.variants[1].price) + Number(this.variants[2].price) - Number(this.duo.price);
      this.querySelector('[data-saving]').hidden = this.offer !== 'pair' || saving <= 0;
      this.querySelector('[data-saving-amount]').textContent = this.money.format(saving);
      const selectedImage = current.image || (basket ? this.duo.image : null);
      if (this.lastVariant !== current.id && selectedImage) {
        const thumb = [...this.querySelectorAll('[data-photo]')].find(photo => photo.dataset.photo === selectedImage);
        thumb?.click();
      }
      this.lastVariant = current.id;
      if (this.sticky) {
        const button = this.sticky.querySelector('[data-sticky-add]');
        button.textContent = this.button.textContent;
        button.disabled = this.button.disabled;
        this.sticky.querySelector('[data-sticky-label]').textContent = basket ? this.words.basket_label : single
          ? this.querySelector('[data-character] option:checked').textContent
          : this.querySelector('input[value="pair"]').closest('label').querySelector('strong').textContent;
      }
    }
    delivery() {
      const now = new Date(), uk = this.dataset.country === 'GB';
      const bits = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
        timeZone: uk ? 'Europe/London' : 'Europe/Rome', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23'
      }).formatToParts(now).map(part => [part.type, part.value]));
      const base = new Date(Date.UTC(+bits.year, +bits.month - 1, +bits.day, 12));
      const from = uk ? 5 : 6;
      const format = new Intl.DateTimeFormat(this.dataset.locale, { day: 'numeric', month: 'long', timeZone: 'UTC' });
      const range = [from, from + 2].map(days => {
        const date = new Date(base);
        date.setUTCDate(date.getUTCDate() + days);
        return format.format(date);
      });
      document.querySelectorAll('[data-delivery], [data-shark-delivery]').forEach(node => node.textContent = range.join(' – '));
      const remaining = 86400 - Number(bits.hour) * 3600 - Number(bits.minute) * 60 - Number(bits.second);
      const clock = [Math.floor(remaining / 3600), Math.floor(remaining % 3600 / 60), remaining % 60].map(value => String(value).padStart(2, '0')).join(':');
      this.querySelector('[data-order-countdown]').textContent = clock;
    }
    async add(event) {
      event.preventDefault();
      if (this.busy) return;
      const error = this.querySelector('[data-error]');
      error.hidden = true;
      if (this.dataset.preview === 'true') {
        error.textContent = this.words.preview;
        error.hidden = false;
        return;
      }
      this.busy = true;
      this.update();
      try {
        const drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.setActiveElement(this.button);
        const payload = { items: [{ id: this.selected.id, quantity: 1 }] };
        if (drawer) {
          payload.sections = drawer.getSectionsToRender().map(section => section.id);
          payload.sections_url = location.pathname;
        }
        const root = this.dataset.root.replace(/\/$/, '');
        const response = await fetch(root + '/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.words.error);
        if (drawer) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(result);
        } else location.assign(root + '/cart');
      } catch (problem) {
        error.textContent = problem.message || this.words.error;
        error.hidden = false;
      } finally {
        this.busy = false;
        this.update();
      }
    }
  });
})();







